import { render } from "./GuarantorInsurance.vue?vue&type=template&id=49a4d09e"
import script from "./GuarantorInsurance.vue?vue&type=script&lang=js"
export * from "./GuarantorInsurance.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/billingInfo/forms/GuarantorInsurance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49a4d09e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49a4d09e', __exports__)) {
    console.log('reload')
    api.reload('49a4d09e', __exports__)
  }
  
  module.hot.accept("./GuarantorInsurance.vue?vue&type=template&id=49a4d09e", () => {
    console.log('re-render')
    api.rerender('49a4d09e', render)
  })

}


export default __exports__